// Load Tawk.to chat widget in production environment
export const loadTawkTo = () => {
    const allowedEnvironments = ['production'];

    // Check both NODE_ENV and REACT_APP_ENV
    const isAllowedEnv = allowedEnvironments.includes(process.env.REACT_APP_ENV);

    if (!isAllowedEnv) {
        console.log(`Tawk.to disabled in ${process.env.REACT_APP_ENV} environment`);
        return;
    }

    console.log('Tawk.to enabled');


    var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
    (function () {
        var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = 'https://embed.tawk.to/65d48b428d261e1b5f62afbd/1hn33vvot';
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
    })();
};

